import { call, put, takeLatest } from 'redux-saga/effects';
import { getCurrentUserApi } from '../../api/user.api';
import {
  getActiveRolesAct,
  getCurrentUserAction,
  getCurrentUserFailedAction,
  getCurrentUserSuccessAction,
  performLogoutAction,
  performLogoutSuccessAction,
  updateViewRoleAct,
} from './actions';
import { logoutApi } from '../../api/auth.api';
import { getCaslRulesApi, getActiveRolesApi } from '../../api/admin.api';
import { LOADING_STATES } from '../../constants/loading-state.constant';

function* getCurrentUser() {
  try {
    const { data } = yield call(getCurrentUserApi);
    if (data) {
      yield put(getCurrentUserSuccessAction(data));
      // set token on storage
    } else {
      yield put(getCurrentUserFailedAction('Something went wrong'));
    }
  } catch (error) {
    const { response } = error;
    let errMessage = 'Something went wrong';
    if (response && response.data) {
      errMessage = response.data.message;
    }
    yield put(getCurrentUserFailedAction(errMessage));
  }
}

function* logoutUser() {
  try {
    const { data } = yield call(logoutApi);
    if (data) {
      yield put(performLogoutSuccessAction(data));
    }
  } catch (error) {
    // continue regardless of error
  }
}

function* fetchRoleRules({ payload }) {
  const { viewRoleChangeState, viewRole } = payload;
  if (viewRoleChangeState === LOADING_STATES.LOADING) {
    try {
      const { data } = yield call(getCaslRulesApi, viewRole.roleName);
      yield put(updateViewRoleAct(LOADING_STATES.SUCCESS, viewRole, data));
    } catch (error) {
      yield put(updateViewRoleAct(LOADING_STATES.ERROR));
    }
  }
}

function* fetchActiveRoles({ payload }) {
  const { rolesLoadingState } = payload;
  if (rolesLoadingState === LOADING_STATES.LOADING) {
    try {
      const { data } = yield call(getActiveRolesApi);
      yield put(getActiveRolesAct(LOADING_STATES.SUCCESS, data));
    } catch (error) {
      yield put(getActiveRolesAct(LOADING_STATES.ERROR));
    }
  }
}

// Individual exports for testing
export default function* authSaga() {
  //  uncomment this to setp default action
  yield takeLatest(getCurrentUserAction.toString(), getCurrentUser);
  yield takeLatest(performLogoutAction.toString(), logoutUser);
  yield takeLatest(updateViewRoleAct.toString(), fetchRoleRules);
  yield takeLatest(getActiveRolesAct.toString(), fetchActiveRoles);
}
